export interface UploadReviewRequestsPayload {
  urls: string[];
}

export const UPLOAD_REVIEW_REQUESTS_API = 'v1/coaches/upload-review-requests';
